import { usModelProductNumbers } from '../us/constants/baseModel'

export const aplSeriesChecker = (productNumber: string): boolean =>
  // 品番を定数で持つべし
  [
    'AGL-NE001(AKG-1)', // 投手
    'AGL-NE011(AKG-21)', // 投手
    'AGL-NE105', // オールラウンド
    'AGL-NE501',
    'AGL-NE102(AKG-5)',
    'AGL-NE801', // 外野手
    'AGL-NE008(AKG-GT07)', // 外野手
    'APL-NE102',
    'APL-NE021',
    'APL-NE026',
    'APL-NE066',
    'APL-NE702', // 外野手
    'APL-UR026+', // ~2024
    'APL-UR004+', // ~2024
    'APL-UR005+', // ~2024
    'APL-UR006+', // ~2024
    'APL-UR066+', // ~2024
    'APL-UR007+', // ~2024
    'APL-UR008+', // ~2024
    'APL-UR003+', // ~2024
    'APL-UR002+', // ~2024
    'APL-UR015+' // ~2024
  ].includes(productNumber)

export const seriesChecker = (
  productNumber: string
): {
  is2025Agl: boolean
  is2025Apl: boolean
  is2024Apl: boolean
  isDefaultWristBelt: boolean
} => {
  const isDefaultWristBelt = [
    'AGL-NE001(AKG-1)', // 投手 2025
    'AGL-NE011(AKG-21)', // 投手 2025
    'AKG-PRO46', // 投手 2024
    'AKG-11', // 投手 2024
    'AKG-JS4+', // 内野 2024
    'AKG-JS5', // 内野 2024
    'AKG-4', // 内野 2024
    'AKG-5', // 内野 2024
    'AKG-6', // 内野 2024
    'AKG-16', // 内野 2024
    'APL-UR4', // 内野 2024
    'AGL-105', // 内野 2024
    'AGL-501', // 内野 2024
    'AKG-GT07', // 外野 2024
    'AKG-7', // 外野 2024
    'AKG-27', // 外野 2024
    'AGL-702', // 外野 2024
    'AGL-801', // 外野 2024
    'AGL-1001', // 少年軟式 2024
    'AGL-1004', // 少年軟式 2024
    'AGL-1006', // 少年軟式 2024
    'AGL-NE003(AKG-GT33)', // 一塁手用 2025
    'AKG-13', // 一塁手用 2024
    'AGL-3001', // 少年一塁手
    'AGL-2001' // 少年捕手
  ].includes(productNumber)

  const is2025Agl = [
    'AGL-NE001(AKG-1)', // 投手
    'AGL-NE011(AKG-21)', // 投手
    'AGL-NE105', // オールラウンド
    'AGL-NE501',
    'AGL-NE102(AKG-5)',
    'AGL-NE801', // 外野手
    'AGL-NE008(AKG-GT07)' // 外野手
  ].includes(productNumber)

  const check2025Apl = (str) => /^APL-NE(102|021|026|066|702)$/.test(str)
  const is2025Apl = check2025Apl(productNumber)
  const check2024Apl = (str) => /^APL-UR(066|006|026|004|005)\+$/.test(str)
  const is2024Apl = check2024Apl(productNumber)
  return {
    is2025Agl,
    is2025Apl,
    is2024Apl,
    isDefaultWristBelt
  }
}
// 品番を定数で持つべし

export const usModelOfAtomsChecker = (productNumberOfSelectedModel: string): boolean => usModelProductNumbers.includes(productNumberOfSelectedModel)
